










































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Exam } from '@/models/exam'
import { ExamRoom } from '@/models/exam/room'
import { Examinees } from '@/models/exam/examinees'

@Component
export default class PrintExamRoomArrangement extends Vue {
  @Prop() exam!: Exam
  @Prop() room!: ExamRoom
  @Prop() examinees!: Examinees[]

  get examTime() {
    const time = this.exam.time
    if (!time) return ''

    const date = new Date(time)
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDay()}日`
  }
}
